import React from 'react';
import { oneTeam } from '../mock';
import Reveal from './Reveal';
import oneTeamImg from '../assets/oneteam-core.jpg';

const OneTeam = () => {
  return (
    <section className="bg-[#262629] px-5 md:px-10 py-8">
      <div className="max-w-[1400px] mx-auto">
        <Reveal>
          <div className="relative rounded-2xl overflow-hidden min-h-[560px] flex items-center">
            <img src={oneTeamImg} alt="Core Estimating on site" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-[#262629]/70" />
            <div className="relative z-10 p-8 md:p-16 max-w-3xl">
              <h2 className="font-display text-6xl md:text-8xl mb-8">
                <span className="text-white">{oneTeam.title[0]}</span><br />
                <span className="text-yellow">{oneTeam.title[1]}</span>
              </h2>
              <p className="text-white/90 text-base md:text-lg leading-relaxed mb-5">{oneTeam.p1}</p>
              <p className="text-white/90 text-base md:text-lg leading-relaxed mb-9">{oneTeam.p2}</p>
              <div className="flex flex-wrap gap-4">
                <a href="#about" className="bg-jaw-yellow text-[#262629] font-semibold px-8 py-4 rounded-[10px] hover:bg-[#e8660a] transition-colors">
                  Learn more about our team
                </a>
                <a href="#contact" className="bg-white text-[#262629] font-semibold px-8 py-4 rounded-[10px] hover:bg-white/85 transition-colors">
                  Talk to us
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default OneTeam;
